import React, { Component, Fragment } from 'react';
import {attackStr} from './utils'

export default class MotEntryTable extends Component {
  render(){
    var {data,selectMot,selectedMotId} = this.props;
    if(!data) return <div>Loading...</div>
    function entry(motEntry,idx){
      var flags = [];
      if(motEntry.startup){
        flags.push({
          name:'attack',
          content:`${attackStr(motEntry.attackFlags)} S:${motEntry.startup} A:${1+motEntry.recovery-motEntry.startup}`
        })
      } else{
        return null
      }
      var selected = idx == selectedMotId;
      return  <tr key={idx} className={selected ? 'selected':''}>
                <td><a onClick={() =>selectMot(idx)}>#{idx.toString(16)} {motEntry.name}</a></td>
                <td>{flags.map((flag,i) => <span key={i} className={"flag "+flag.name}>{flag.content}</span>)}</td>
              </tr>
    }
    //return <pre>{JSON.stringify(data.states,null,2)}</pre>
    return <table className="compactTable u-full-width">
        <thead>
          <tr><th colSpan="2" className="alt">Select State</th></tr>
          <tr>
            <th>State</th>
            <th>Flags</th>
          </tr>
        </thead>
        <tbody>
          {data.states.map(entry)}
        </tbody>
      </table>

  }
}



// WEBPACK FOOTER //
// ./src/MotEntryTable.js